import { motion, useReducedMotion } from 'framer-motion'

const CHIPS = ['10', '50', '100', '250']

// Step 1 — quick-stake chips, one selected (accent). Shared across games.
const StakeVisual = () => {
  const reduce = useReducedMotion()

  return (
    <div className="htp-stake">
      <span className="htp-vlabel">Stake</span>
      <div className="htp-chips">
        {CHIPS.map((chip, index) => (
          <motion.span
            key={chip}
            className={`htp-chip ${index === 1 ? 'is-selected' : ''}`}
            initial={reduce ? false : { opacity: 0, y: 8 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: reduce ? 0 : index * 0.06, duration: 0.25 }}
          >
            {chip}
          </motion.span>
        ))}
      </div>
    </div>
  )
}

export default StakeVisual
